<template>
    <div>
        <div>
            <b-alert
                v-if="!groupIn.group_pair_options"
                variant="info"
                show>
                {{
                    $t(
                        'group.settings.please_note_you_must_click_save_at_the_bottom_before_the_group_creation_tool_is_actually_enabled'
                    )
                }}
            </b-alert>
            <b-button
                class="btn-page-content-toggle header-active"
                block
                variant="outline-primary"
                :class="visibleGeneral ? 'not-collapsed' : 'collapsed'"
                :aria-expanded="visibleGeneral ? 'true' : 'false'"
                aria-controls="group-management-general"
                @click="visibleGeneral = !visibleGeneral">
                <div class="title">
                    <div class="page-title">
                        {{ $t('group.settings.general') }}
                    </div>
                </div>

                <i class="fas fa-fw fa-chevron-down state-icon"></i>
            </b-button>
            <b-collapse
                id="group-management-general"
                v-model="visibleGeneral">
                <design-2021-apprentice-data-table
                    class="group-management-default-options-table"
                    striped
                    responsive
                    stacked="sm"
                    hover
                    :items="itemsGeneral"
                    :fields="fields"
                    :nosearch="true">
                    <template #head(choice)="data">
                        <div class="choice-header">{{ data.label }}</div>
                    </template>

                    <template v-slot:cell(option)="data">
                        <div class="general-option-name">
                            {{ data.item.option }}
                        </div>
                    </template>

                    <template v-slot:cell(toggle)="data">
                        <div class="general-switch-toggle">
                            <b-form-checkbox
                                v-model="data.item.switchValue"
                                v-if="data.item.hasSwitch"
                                name="group-management-choice-toggle"
                                switch>
                            </b-form-checkbox>
                        </div>
                    </template>

                    <!--                        select -->
                    <template v-slot:cell(choice)="data">
                        <div class="options-general">
                            <b-form-select
                                class="apprentice-primary-select"
                                v-model="data.item.selectValue"
                                v-if="
                                    data.item.hasSelect &&
                                    canShowSelectGeneral(data.item) &&
                                    data.item.key !== 'partner_min' &&
                                    data.item.key !== 'partner_max'
                                "
                                :options="data.item.selectOptions">
                            </b-form-select>

                            <b-form-input
                                v-if="data.item.key === 'partner_min' && canShowSelectGeneral(data.item)"
                                v-model="partner_min"
                                :placeholder="$t('group.settings.no_minimum_value')"
                                type="number"
                                min="0"></b-form-input>

                            <b-form-input
                                v-if="data.item.key === 'partner_max' && canShowSelectGeneral(data.item)"
                                v-model="partner_max"
                                :placeholder="$t('group.settings.no_maximum_value')"
                                type="number"
                                min="0"></b-form-input>
                        </div>
                    </template>
                </design-2021-apprentice-data-table>
            </b-collapse>

            <b-button
                class="btn-page-content-toggle"
                block
                variant="outline-primary"
                :class="[
                    visibleTeacher ? 'not-collapsed' : 'collapsed',
                    itemsTeachers[0].switchValue ? 'header-active' : 'header-disabled',
                ]"
                :aria-expanded="visibleTeacher ? 'true' : 'false'"
                aria-controls="group-management-teacher"
                @click="visibleTeacher = !visibleTeacher">
                <div class="title">
                    <div class="page-title">
                        {{ $t('group.settings.teacher_choice') }}
                    </div>
                </div>

                <i class="fas fa-fw fa-chevron-down state-icon"></i>
            </b-button>
            <b-collapse
                id="group-management-teacher"
                v-model="visibleTeacher">
                <b-alert
                    v-if="teacherMaxDoesntCompute"
                    variant="danger"
                    show>
                    {{
                        $t(
                            'group.settings.it_seems_that_the_teacher_is_mandatory_while_maximum_number_of_teachers_is_set_to_0_this_is_not_possible'
                        )
                    }}
                </b-alert>
                <design-2021-apprentice-data-table
                    class="group-management-teacher-options-table"
                    striped
                    responsive
                    stacked="sm"
                    hover
                    :items="itemsTeachers"
                    :fields="fields"
                    :nosearch="true">
                    <template #head(choice)="data">
                        <div class="choice-header">{{ data.label }}</div>
                    </template>

                    <template v-slot:cell(option)="data">
                        <div class="teacher-option-name">
                            {{ data.item.option }}
                        </div>
                    </template>

                    <template v-slot:cell(toggle)="data">
                        <div class="teacher-switch-toggle">
                            <b-form-checkbox
                                v-if="data.item.hasSwitch"
                                v-model="data.item.switchValue"
                                name="group-management-choice-toggle"
                                switch>
                            </b-form-checkbox>
                        </div>
                    </template>

                    <!--                        select -->
                    <template v-slot:cell(choice)="data">
                        <div class="options">
                            <b-form-select
                                class="apprentice-primary-select"
                                v-model="data.item.selectValue"
                                v-if="
                                    data.item.hasSelect &&
                                    canShowSelectTeachers(data.item) &&
                                    data.item.key !== 'max_teachers'
                                "
                                :options="data.item.selectOptions">
                            </b-form-select>

                            <b-form-input
                                v-if="data.item.key === 'max_teachers' && canShowSelectTeachers(data.item)"
                                v-model="max_teachers"
                                type="number"
                                min="0"></b-form-input>
                        </div>
                    </template>
                </design-2021-apprentice-data-table>
            </b-collapse>

            <b-button
                class="btn-page-content-toggle"
                block
                variant="outline-primary"
                :class="[
                    visibleCourses ? 'not-collapsed' : 'collapsed',
                    itemsCourses[0].switchValue ? 'header-active' : 'header-disabled',
                ]"
                :aria-expanded="visibleCourses ? 'true' : 'false'"
                aria-controls="group-management-course"
                @click="visibleCourses = !visibleCourses">
                <div class="title">
                    <div class="page-title">
                        {{ $t('group.settings.profile_course_choice') }}
                    </div>
                </div>

                <i class="fas fa-fw fa-chevron-down state-icon"></i>
            </b-button>
            <b-collapse
                id="group-management-course"
                v-model="visibleCourses">
                <design-2021-apprentice-data-table
                    class="group-management-course-option-table"
                    striped
                    responsive
                    stacked="sm"
                    hover
                    :items="itemsCourses"
                    :fields="fields"
                    :nosearch="true">
                    <template #head(choice)="data">
                        <div class="choice-header">{{ data.label }}</div>
                    </template>

                    <template v-slot:cell(option)="data">
                        <div class="course-option-name">
                            {{ data.item.option }}
                        </div>
                    </template>

                    <template v-slot:cell(toggle)="data">
                        <div class="course-switch-toggle">
                            <b-form-checkbox
                                v-model="data.item.switchValue"
                                v-if="data.item.hasSwitch && data.item.key === 'course'"
                                name="group-management-choice-toggle"
                                switch>
                            </b-form-checkbox>

                            <b-form-checkbox
                                v-model="data.item.switchValue"
                                v-if="
                                    data.item.hasSwitch &&
                                    data.item.key === 'course_custom' &&
                                    canShowCourseCustomSwitch
                                "
                                name="group-management-choice-toggle"
                                switch>
                            </b-form-checkbox>

                            <b-form-checkbox
                                v-model="data.item.switchValue"
                                v-if="
                                    data.item.hasSwitch &&
                                    data.item.key === 'course_student_link' &&
                                    canShowCourseCustomSwitch
                                "
                                name="group-management-choice-toggle"
                                switch>
                            </b-form-checkbox>
                        </div>
                    </template>

                    <!-- select -->
                    <template v-slot:cell(choice)="data">
                        <div class="options">
                            <b-form-select
                                class="apprentice-primary-select"
                                v-model="data.item.selectValue"
                                v-if="
                                    data.item.hasSelect && canShowSelectCourse(data.item) && data.item.key === 'course'
                                "
                                :options="data.item.selectOptions">
                            </b-form-select>

                            <b-form-input
                                v-if="data.item.key === 'course_min' && canShowSelectCourse(data.item)"
                                v-model="course_min"
                                :placeholder="$t('group.settings.no_minimum_value')"
                                type="number"
                                min="0"></b-form-input>

                            <b-form-input
                                v-if="data.item.key === 'course_max' && canShowSelectCourse(data.item)"
                                v-model="course_max"
                                :placeholder="$t('group.settings.no_maximum_value')"
                                type="number"
                                min="0"></b-form-input>

                            <b-form-select
                                class="apprentice-primary-select"
                                v-model="data.item.selectValue"
                                v-if="
                                    data.item.hasSelect &&
                                    canShowSelectCourse(data.item) &&
                                    data.item.key === 'course_student_link'
                                "
                                :options="data.item.selectOptions">
                            </b-form-select>

                            <design-2021-apprentice-multiselect-component
                                v-model="data.item.selectValue"
                                v-if="
                                    data.item.hasSelect &&
                                    canShowSelectCourse(data.item) &&
                                    data.item.key === 'course_custom' &&
                                    data.item.switchValue
                                "
                                :options="data.item.selectOptions"
                                text-field="name"
                                value-field="id"
                                label="name"
                                track-by="id">
                            </design-2021-apprentice-multiselect-component>
                        </div>
                    </template>
                </design-2021-apprentice-data-table>
            </b-collapse>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-grouppair-options-component',
    props: ['groupIn', 'coursesIn'],
    data() {
        return {
            itemsGeneral: [
                {
                    option: this.$t('group.settings.collaboration_partner'),
                    key: 'cooperation_partner',
                    hasSwitch: true,
                    switchValue: this.switchIsEnabledForOption(this.groupIn?.group_pair_options?.cooperation_partner),
                    hasSelect: false
                },
                {
                    option: this.$t('group.settings.minimum_amount_of_students_in_group_optional'),
                    key: 'partner_min',
                    hasSwitch: false,
                    hasSelect: true
                },
                {
                    option: this.$t('group.settings.maximum_amount_of_students_optional'),
                    key: 'partner_max',
                    hasSwitch: false,
                    hasSelect: true
                },
                {
                    option: this.$t('group.settings.subject'),
                    key: 'topic',
                    hasSwitch: true,
                    switchValue: this.switchIsEnabledForOption(this.groupIn?.group_pair_options?.topic),
                    hasSelect: true,
                    selectOptions: [
                        { value: null, text: this.$t('group.settings.make_a_choice'), disabled: true },
                        { value: 1, text: this.$t('group.settings.mandatory') },
                        { value: 2, text: this.$t('group.settings.approval') }
                    ],
                    selectValue: this.groupIn.group_pair_options
                        ? this.groupIn.group_pair_options && this.groupIn.group_pair_options.topic_option
                            ? this.groupIn.group_pair_options.topic_option
                            : null
                        : null
                },
                {
                    option: this.$t('group.settings.approval'),
                    key: 'check',
                    hasSwitch: false,
                    hasSelect: true,
                    selectOptions: [
                        { value: 1, text: this.$t('group.settings.teacher') },
                        { value: 2, text: this.$t('group.settings.teacher_and_administrator') },
                        { value: 3, text: this.$t('group.settings.administrator') }
                    ],
                    selectValue: this.groupIn.group_pair_options
                        ? this.groupIn.group_pair_options && this.groupIn.group_pair_options.check_option
                            ? this.groupIn.group_pair_options.check_option
                            : 1
                        : 1
                },
                {
                    option: this.$t('group.settings.argumentation'),
                    key: 'argumentation',
                    hasSwitch: true,
                    switchValue: this.switchIsEnabledForOption(this.groupIn?.group_pair_options?.argumentation_option),
                    hasSelect: true,
                    selectOptions: [
                        { value: null, text: this.$t('group.settings.make_a_choice'), disabled: true },
                        { value: 1, text: this.$t('group.settings.mandatory') },
                        { value: 2, text: this.$t('group.settings.optional') }
                    ],
                    selectValue: this.groupIn.group_pair_options
                        ? this.groupIn.group_pair_options && this.groupIn.group_pair_options.argumentation_option
                            ? this.groupIn.group_pair_options.argumentation_option
                            : null
                        : null
                },
                {
                    option: this.$t('group.settings.appendix'),
                    key: 'upload',
                    hasSwitch: true,
                    switchValue: this.switchIsEnabledForOption(this.groupIn?.group_pair_options?.upload_option),
                    hasSelect: true,
                    selectOptions: [
                        { value: null, text: this.$t('group.settings.make_a_choice'), disabled: true },
                        { value: 1, text: this.$t('group.settings.mandatory') },
                        { value: 2, text: this.$t('group.settings.optional') }
                    ],
                    selectValue: this.groupIn.group_pair_options
                        ? this.groupIn.group_pair_options && this.groupIn.group_pair_options.upload_option
                            ? this.groupIn.group_pair_options.upload_option
                            : null
                        : null
                }
            ],
            itemsTeachers: [
                {
                    option: this.$t('group.settings.teacher_choice'),
                    key: 'teacher',
                    hasSwitch: true,
                    switchValue: this.switchIsEnabledForOption(this.groupIn?.group_pair_options?.teacher),
                    hasSelect: true,
                    selectOptions: [
                        { value: null, text: this.$t('group.settings.make_a_choice'), disabled: true },
                        { value: 1, text: this.$t('group.settings.mandatory') },
                        { value: 2, text: this.$t('group.settings.optional') }
                    ],
                    selectValue: this.groupIn.group_pair_options
                        ? this.groupIn.group_pair_options && this.groupIn.group_pair_options.teacher_option
                            ? this.groupIn.group_pair_options.teacher_option
                            : null
                        : null
                },
                {
                    option: this.$t('group.settings.teacher_maximum_amount_of_requests'),
                    key: 'teacher_force_max',
                    hasSwitch: false,
                    hasSelect: true,
                    selectOptions: [
                        { value: 1, text: this.$t('group.settings.equal_to_the_max_number_of_groups_of_teacher') },
                        {
                            value: 0,
                            text: this.$t('group.settings.may_be_higher_than_the_max_number_of_teacher_groups')
                        }
                    ],
                    selectValue: this.groupIn.group_pair_options
                        ? this.groupIn.group_pair_options.teacher
                            ? this.groupIn.group_pair_options.teacher_force_max
                            : 1
                        : 1
                },
                {
                    option: this.$t('group.settings.maximum_number_of_teachers_to_be_chosen'),
                    key: 'max_teachers',
                    hasSwitch: false,
                    hasSelect: true
                }
            ],
            itemsCourses: [
                {
                    option: this.$t('group.settings.profile_subject_choice'),
                    key: 'course',
                    hasSwitch: true,
                    switchValue: this.switchIsEnabledForOption(this.groupIn?.group_pair_options?.course),
                    hasSelect: true,
                    selectOptions: [
                        { value: null, text: this.$t('group.settings.make_a_choice'), disabled: true },
                        { value: 1, text: this.$t('group.settings.mandatory') },
                        { value: 2, text: this.$t('group.settings.optional') }
                    ],
                    selectValue: this.groupIn.group_pair_options
                        ? this.groupIn.group_pair_options && this.groupIn.group_pair_options.course_option
                            ? this.groupIn.group_pair_options.course_option
                            : null
                        : null
                },
                {
                    option: this.$t('group.settings.amount_of_courses_min_optional'),
                    key: 'course_min',
                    hasSwitch: false,
                    hasSelect: true
                },
                {
                    option: this.$t('group.settings.amount_of_courses_max_optional'),
                    key: 'course_max',
                    hasSwitch: false,
                    hasSelect: true
                },
                {
                    option: this.$t('group.settings.custom_courses'),
                    key: 'course_custom',
                    hasSwitch: true,
                    switchValue: this.switchIsEnabledForOption(this.groupIn?.group_pair_options?.course_custom),
                    hasSelect: true,
                    selectOptions: this.coursesIn,
                    selectValue: this.groupIn.group_pair_options
                        ? !this.groupIn.group_pair_options.courses.length
                            ? []
                            : this.coursesIn.filter((course) => {
                                return this.groupIn.group_pair_options.courses.some((optionCourse) => {
                                    return optionCourse.id === course.id;
                                });
                            })
                        : []
                },
                {
                    option: this.$t('group.settings.indicate_by_student_which_subject_is_used'),
                    key: 'course_student_link',
                    hasSwitch: true,
                    switchValue: this.switchIsEnabledForOption(this.groupIn?.group_pair_options?.course_student_link),
                    hasSelect: true,
                    selectOptions: [
                        { value: null, text: this.$t('group.settings.make_a_choice'), disabled: true },
                        { value: 1, text: this.$t('group.settings.mandatory') },
                        { value: 2, text: this.$t('group.settings.optional') }
                    ],
                    selectValue: this.groupIn.group_pair_options
                        ? this.groupIn.group_pair_options && this.groupIn.group_pair_options.course_option
                            ? this.groupIn.group_pair_options.course_student_link
                            : null
                        : null
                }
            ],
            errors: false,
            visibleGeneral: true,
            visibleTeacher: true,
            visibleCourses: true,
            fields: [
                {
                    key: 'option',
                    label: this.$t('group.settings.option')
                },
                {
                    key: 'toggle',
                    label: this.$t('group.settings.on_off')
                },
                {
                    key: 'choice',
                    label: this.$t('group.settings.choice')
                }
            ],
            partner_min: this.groupIn.group_pair_options && this.groupIn.group_pair_options.partner_min,
            partner_max: this.groupIn.group_pair_options && this.groupIn.group_pair_options.partner_max,
            max_teachers:
                this.groupIn.group_pair_options && this.groupIn.group_pair_options.max_teachers !== null
                    ? this.groupIn.group_pair_options.max_teachers
                    : 1,
            course_min: this.groupIn.group_pair_options && this.groupIn.group_pair_options.course_min,
            course_max: this.groupIn.group_pair_options && this.groupIn.group_pair_options.course_max,
            course_student_link:
                this.groupIn.group_pair_options && this.groupIn.group_pair_options.course_student_link
        };
    },
    methods: {
        canShowSelectGeneral(item) {
            switch (item.key) {
                case 'partner_min':
                case 'partner_max':
                    return this.itemsGeneral.find((item) => item.key === 'cooperation_partner').switchValue;
                case 'argumentation':
                case 'upload':
                case 'topic':
                    return item.switchValue;
                case 'check':
                    return true;
            }
        },
        canShowSelectTeachers(item) {
            switch (item.key) {
                case 'teacher':
                    return item.switchValue;
                case 'teacher_force_max':
                    return this.itemsTeachers.find((item) => item.key === 'teacher').switchValue;
                case 'max_teachers':
                    return this.itemsTeachers.find((item) => item.key === 'teacher').switchValue;
            }
        },
        canShowSelectCourse(item) {
            switch (item.key) {
                case 'course':
                    return item.switchValue;
                case 'course_min':
                case 'course_max':
                case 'course_student_link':
                case 'course_custom':
                    return this.itemsCourses.find((item) => item.key === 'course').switchValue;
            }
        },
        getData() {
            this.errors = false;

            const cooperationPartnerItem = this.itemsGeneral.find((item) => item.key === 'cooperation_partner');
            const topicItem = this.itemsGeneral.find((item) => item.key === 'topic');
            const checkItem = this.itemsGeneral.find((item) => item.key === 'check');
            const argumentationItem = this.itemsGeneral.find((item) => item.key === 'argumentation');
            const uploadItem = this.itemsGeneral.find((item) => item.key === 'upload');

            const teacherItem = this.itemsTeachers.find((item) => item.key === 'teacher');
            const teacherForceMaxItem = this.itemsTeachers.find((item) => item.key === 'teacher_force_max');

            const courseItem = this.itemsCourses.find((item) => item.key === 'course');
            const courseCustomItem = this.itemsCourses.find((item) => item.key === 'course_custom');
            const courseStudentLink = this.itemsCourses.find((item) => item.key === 'course_student_link');

            if (
                (teacherItem.switchValue && !teacherItem.selectValue) ||
                (courseItem.switchValue && !courseItem.selectValue) ||
                (topicItem.switchValue && !topicItem.selectValue) ||
                (argumentationItem.switchValue && !argumentationItem.selectValue) ||
                (uploadItem.switchValue && !uploadItem.selectValue) ||
                this.teacherMaxDoesntCompute ||
                (courseStudentLink.switchValue && !courseStudentLink.selectValue)
            ) {
                this.errors = true;
            }
            const data = {
                cooperation_partner: cooperationPartnerItem.switchValue ? 1 : 0,
                partner_min: this.partner_min,
                partner_max: this.partner_max,
                teacher: teacherItem.switchValue ? 1 : 0,
                teacher_option: teacherItem.switchValue ? teacherItem.selectValue : null,
                teacher_force_max: teacherItem.switchValue ? teacherForceMaxItem.selectValue : null,
                max_teachers: this.max_teachers,
                course: courseItem.switchValue ? 1 : 0,
                course_option: courseItem.switchValue ? courseItem.selectValue : null,
                topic: topicItem.switchValue ? 1 : 0,
                topic_option: topicItem.switchValue ? topicItem.selectValue : null,
                argumentation: argumentationItem.switchValue ? 1 : 0,
                argumentation_option: argumentationItem.switchValue ? argumentationItem.selectValue : null,
                check_option: checkItem.selectValue,
                upload: uploadItem.switchValue ? 1 : 0,
                upload_option: uploadItem.switchValue ? uploadItem.selectValue : 0,
                group_id: this.groupIn.id,
                course_min: courseItem.switchValue ? this.course_min : 0,
                course_max: courseItem.switchValue ? this.course_max : 0,
                errors: this.errors,
                course_custom:
                    courseItem.switchValue && courseCustomItem.switchValue
                        ? courseCustomItem.selectValue.map((course) => course.id)
                        : [],
                course_student_link: courseStudentLink.switchValue ? courseStudentLink.selectValue : null
            };
            return data;
        },
        switchIsEnabledForOption(option) {
            return option !== 0 && option !== null;
        }
    },
    computed: {
        canShowCourseCustomSwitch() {
            return this.itemsCourses.find((item) => item.key === 'course').switchValue;
        },
        teacherMaxDoesntCompute() {
            const teacher = !!this.itemsTeachers.find((item) => item.key === 'teacher').switchValue;
            const maxTeachers = !!parseInt(this.max_teachers);
            if (teacher) {
                return !maxTeachers;
            } else {
                return false;
            }
        }
    }
};
</script>

<style scoped lang="scss">
.description {
    margin-left: 12px;
}

.btn-page-content-toggle {
    justify-content: space-between;
    outline: none;
    box-shadow: none;
    border-radius: $border-radius-content;
    border: none;
    line-height: 1;
    font-weight: 700;
    height: 55px;
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

    &,
    .title {
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #fff;
    }

    .state-icon {
        transform-origin: center;
        transition: all 0.8s ease;
        margin-left: auto;
        margin-right: map-get($grid-gutter-spacing, 'fifteen');
    }

    &:hover {
        background-color: $info;
        font-weight: $font-weight-bold;

        .title {
            color: $white;
        }
    }

    &.not-collapsed {
        font-weight: $font-weight-bold;

        .state-icon {
            transform: rotate(-180deg);
        }
    }
}

.header-active {
    background-color: var(--primary);

    title {
        color: $white;
    }
}

.header-disabled {
    background-color: $border-color;

    .title {
        color: $text-muted-color;
    }
}

input.form-control,
.apprentice-input-field,
.apprentice-primary-select {
    margin-bottom: 0;
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    ::v-deep .group-management-default-options-table,
    ::v-deep .group-management-teacher-options-table,
    ::v-deep .group-management-course-option-table {
        tbody {
            tr td {
                height: 77px;

                &:nth-child(1) {
                    > div {
                        width: 225px;
                    }
                }

                &:nth-child(2) {
                    > div {
                        width: 50px;
                    }
                }

                &:nth-child(3) {
                    > div {
                        width: 250px;
                    }
                }
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    ::v-deep .group-management-default-options-table,
    ::v-deep .group-management-teacher-options-table,
    ::v-deep .group-management-course-option-table {
        tbody {
            tr td {
                &:nth-child(1) {
                    > div {
                        width: 250px;
                    }
                }

                &:nth-child(2) {
                    > div {
                        width: 115px;
                    }
                }
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    ::v-deep .group-management-default-options-table,
    ::v-deep .group-management-teacher-options-table,
    ::v-deep .group-management-course-option-table {
        tbody {
            tr td {
                height: 77px;

                &:nth-child(1) {
                    > div {
                        width: 200px;
                    }
                }

                &:nth-child(2) {
                    > div {
                        width: 150px;
                    }
                }

                &:nth-child(3) {
                    > div {
                        width: 250px;
                    }
                }
            }
        }
    }
}
</style>
